import * as tslib_1 from "tslib";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * NormalBasicChunk is the default method for standard tangent-space normal mapping.
 */
var NormalBasicChunk = (function (_super) {
    tslib_1.__extends(NormalBasicChunk, _super);
    /**
     * Creates a new EffectEnvMapChunk.
     */
    function NormalBasicChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    NormalBasicChunk.prototype._isUsed = function () {
        if (this._texture && this._shader.normalDependencies)
            return true;
        return false;
    };
    /**
     * @inheritDoc
     */
    NormalBasicChunk.prototype._initVO = function (chunkVO) {
        if (this._method.texture) {
            this._texture = this._shader.getAbstraction(this._method.texture);
            this._shader.uvDependencies++;
        }
    };
    /**
     * Indicates whether or not this method outputs normals in tangent space. Override for object-space normals.
     */
    NormalBasicChunk.prototype._outputsTangentNormals = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    NormalBasicChunk.prototype._activate = function () {
        if (this._texture)
            this._texture.activate();
    };
    NormalBasicChunk.prototype._setRenderState = function (renderable, projection) {
        if (this._texture)
            this._texture._setRenderState(renderable);
    };
    /**
     * @inheritDoc
     */
    NormalBasicChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = "";
        if (this._texture)
            code += this._texture._getFragmentCode(targetReg, registerCache, sharedRegisters, sharedRegisters.uvVarying);
        code += "sub " + targetReg + ".xyz, " + targetReg + ".xyz, " + sharedRegisters.commons + ".xxx\n" +
            "nrm " + targetReg + ".xyz, " + targetReg + "\n";
        return code;
    };
    return NormalBasicChunk;
}(ShaderChunkBase));
export { NormalBasicChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/NormalBasicChunk.js